import ErrorStatus from './ErrorStatus';

export const ExceptionsToBeLoggedToSentry = [
  ErrorStatus.BadRequest,
  ErrorStatus.HandledUnknownException,
  ErrorStatus.UnHandledException
];
